import React from 'react';
import {
  WarrantyOptionsGrid as StyledWarrantyOptionsGrid,
  WarrantyOptionsRow,
  WarrantyCenteredOption,
} from '../styles/warrantyStyles';
import { WarrantyOptionCard } from './WarrantyOptionCard';
import { warrantyOptions } from '../servicesEnum';

export const WarrantyOptionsGrid = ({ selectedWarrantyOption, onWarrantyOptionSelection }) => {
  return (
    <StyledWarrantyOptionsGrid>
      <WarrantyCenteredOption>
        {warrantyOptions.slice(0, 1).map(option => (
          <WarrantyOptionCard
            key={option.key}
            option={option}
            isSelected={selectedWarrantyOption === option.key}
            onClick={() => onWarrantyOptionSelection(option.key)}
            isMinor={false}
          />
        ))}
      </WarrantyCenteredOption>
      <WarrantyOptionsRow columns={2}>
        {warrantyOptions.slice(1, 3).map(option => (
          <WarrantyOptionCard
            key={option.key}
            option={option}
            isSelected={selectedWarrantyOption === option.key}
            onClick={() => onWarrantyOptionSelection(option.key)}
            isMinor={false}
          />
        ))}
      </WarrantyOptionsRow>

      <WarrantyOptionsRow columns={2}>
        {warrantyOptions.slice(3, 5).map(option => (
          <WarrantyOptionCard
            key={option.key}
            option={option}
            isSelected={selectedWarrantyOption === option.key}
            onClick={() => onWarrantyOptionSelection(option.key)}
            isMinor={true}
          />
        ))}
      </WarrantyOptionsRow>
    </StyledWarrantyOptionsGrid>
  );
};
